const faq = () => {
    const page = jQuery('#faq');

    if (page) {
        jQuery('.question').on('click', function(evt) {
            evt.preventDefault();

            if (jQuery(this).hasClass('opened')) {
                jQuery(this).removeClass('opened');
                jQuery(`#question_answer-${jQuery(this).data('id')}`).removeClass('active');
            }
            else {
                jQuery(this).addClass('opened');
                jQuery(`#question_answer-${jQuery(this).data('id')}`).addClass('active');
            }
        });

        jQuery.fn.delayKeyup = function(callback, ms){
            var timer = 0;
            jQuery(this).keyup(function(){
                clearTimeout (timer);
                timer = setTimeout(callback, ms);
            });
            return jQuery(this);
        };

        jQuery('#search-faq').delayKeyup(function() {
            let keyword = jQuery.trim(jQuery('#search-faq').val());

            jQuery.ajax({
                url: woosw_vars.ajax_url,
                type: 'POST',
                data: {'action': 'search_faq_ajax', 'keyword': keyword}
            }).done(function(data) {
                if (data !== '') {
                    jQuery('.search-faq-results').html(data).show();
                }
                else {
                    jQuery('.search-faq-results').html('').hide();
                }
            });
        }, 500);

        /*
        jQuery('#search-faq').on('keyup', delay(function() {

        }, 500));
        */
    }
}

export default faq;
